/** Impls dos use cases acadêmicos (S3). @since S3 */
import type {
  Noticia, UpsertNoticiaCommand,
  NotasMultidisciplinar, CpaRelatorioAnalitico,
} from '@/domain/model/AcadGaps';
import type {
  NoticiaGateway, NotasMultidisciplinarGateway, CpaRelatorioAnaliticoGateway,
} from '@/application/port/out/AcadGapsGateways';
import type {
  ListNoticiasUseCase, CreateNoticiaUseCase, UpdateNoticiaUseCase, RemoveNoticiaUseCase,
  GetNotasMultidisciplinarUseCase, GetCpaRelatorioAnaliticoUseCase,
} from '@/application/port/in/AcadGapsUseCase';

export class ListNoticias implements ListNoticiasUseCase {
  constructor(private readonly g: NoticiaGateway) {}
  execute(): Promise<Noticia[]> { return this.g.list(); }
}
export class CreateNoticia implements CreateNoticiaUseCase {
  constructor(private readonly g: NoticiaGateway) {}
  execute(cmd: UpsertNoticiaCommand): Promise<Noticia> { return this.g.create(cmd); }
}
export class UpdateNoticia implements UpdateNoticiaUseCase {
  constructor(private readonly g: NoticiaGateway) {}
  execute(id: string, cmd: UpsertNoticiaCommand): Promise<Noticia> { return this.g.update(id, cmd); }
}
export class RemoveNoticia implements RemoveNoticiaUseCase {
  constructor(private readonly g: NoticiaGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}

export class GetNotasMultidisciplinar implements GetNotasMultidisciplinarUseCase {
  constructor(private readonly g: NotasMultidisciplinarGateway) {}
  execute(cohortId: string): Promise<NotasMultidisciplinar> { return this.g.get(cohortId); }
}
export class GetCpaRelatorioAnalitico implements GetCpaRelatorioAnaliticoUseCase {
  constructor(private readonly g: CpaRelatorioAnaliticoGateway) {}
  execute(cicloId: string): Promise<CpaRelatorioAnalitico> { return this.g.get(cicloId); }
}
